/* eslint-disable id-length */
/* eslint-disable max-lines-per-function */
/* eslint-disable max-len */
/* eslint-disable max-lines */
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { TableUtility } from '@utility/dynamic-table';
import { useAuth } from '../../../Hooks/useAuth';
import { getStaffingMisBaseURL } from '../../../Api/request/staffingMis';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './StaffingMis.scss';
import WeeklyBenchReport from './WeeklyBenchReport';
import WeeklyUtilizationReport from './WeeklyUtilizationReport/weeklyUtilizationReport';

const PAGE_SIZE = 10;
const baseURL = getStaffingMisBaseURL();
const DEFAULT_PAGINATION_CONFIG = {
  page: 1,
  limit: PAGE_SIZE,
  total: 0,
  rowsPerPageOptions: [10, 20, 50, 100],
};

const defaultDate = new Date();
const defaultSelectedDate = [defaultDate.getFullYear(), String(defaultDate.getMonth() + 1).padStart(2, '0'),
  String(defaultDate.getDate()).padStart(2, '0')].join('-');
const defaultStartYear = defaultDate.getMonth() + 1 > 3 ? defaultDate.getFullYear()
  : defaultDate.getFullYear() - 1;
const defaultTeamSizeTitle = `Team Size(FY ${defaultStartYear}-${defaultStartYear + 1})`;

// Global filter config for the page (Date and Sections)
const mockGlobalConfiguration = [
  {
    field: 'selectedDate',
    header: 'Date',
    width: 150,
    filter: true,
    visible: false,
    sortable: false,
    pinnable: false,
    defaultPinned: false,
    isGlobalFilter: true,
    showFilterButtonInHeader: false,
    showPinButtonInHeader: false,
    menuItems: [
      {
        label: 'Date',
        items: [
          {
            type: 'filter',
            field: 'selectedDate',
            label: 'Date',
            template: 'dayCalendar',
            placeholder: 'Select Date',
            selectedValue: defaultSelectedDate,
            selectedValues: [defaultSelectedDate],
            value: defaultSelectedDate,
          },
        ],
      },
    ],
  },
  {
    field: 'sections',
    header: 'Sections',
    width: 150,
    filter: true,
    visible: false,
    sortable: false,
    pinnable: false,
    defaultPinned: false,
    isGlobalFilter: true,
    showFilterButtonInHeader: false,
    showPinButtonInHeader: false,
    menuItems: [
      {
        label: 'Sections',
        items: [
          {
            type: 'filter',
            field: 'sections',
            label: 'Sections',
            template: 'multiSelect',
            placeholder: 'Select Sections',
            selectedValues: ['Team Size', 'Weekly Bench Report', 'Weekly Utilization Report'],
            value: ['Team Size', 'Weekly Bench Report', 'Weekly Utilization Report'],
            options: [
              { label: defaultTeamSizeTitle, value: 'Team Size' },
              { label: 'Weekly Bench Report', value: 'Weekly Bench Report' },
              { label: 'Weekly Utilization Report', value: 'Weekly Utilization Report' },
            ],
            values: [],
          },
        ],
      },
    ],
  },
];

// 1. Role Wise Summary Mock Config
const initialMockRoleWiseSummaryConfig = [
  { field: 'breakup', header: 'Breakup', visible: true, width: 200 },
  { field: 'allocation', header: 'Allocation %', visible: true, width: 150 },
  { field: 'totalCount', header: 'Total Count', visible: true, width: 120 },
  { field: 'appMod', header: 'App Mod', visible: true, width: 100 },
  { field: 'cloudOps', header: 'Cloud Ops', visible: true, width: 110 },
  { field: 'dataMod', header: 'Data Mod', visible: true, width: 110 },
  { field: 'delivery', header: 'Delivery', visible: true, width: 100 },
  { field: 'global', header: 'Global', visible: true, width: 100 },
  { field: 'infraMod', header: 'Infra Mod', visible: true, width: 100 },
  { field: 'managedServices', header: 'Managed Services', visible: true, width: 150 },
  { field: 'productsPlatform', header: 'Products and Platform', visible: true, width: 180 },
  { field: 'reseller', header: 'Reseller', visible: true, width: 100 },
  { field: 'technology', header: 'Technology', visible: true, width: 100 },
];

// 2. Bench Forecast Mock Config
const initialMockBenchForecastConfig = [
  { field: 'weekEnding', header: 'Week Ending', visible: true, width: 120 },
  { field: 'teamSize', header: 'Team Size', visible: true, width: 100 },
  { field: 'totalBenchForecast', header: 'Total Bench Forecast', visible: true, width: 180 },
  { field: 'appMod', header: 'App Mod', visible: true, width: 100 },
  { field: 'dataMod', header: 'Data Mod', visible: true, width: 100 },
  { field: 'infraMod', header: 'Infra Mod', visible: true, width: 100 },
  { field: 'delivery', header: 'Delivery', visible: true, width: 100 },
  { field: 'managedServices', header: 'Managed Services', visible: true, width: 150 },
  { field: 'preSales', header: 'Pre-Sales', visible: true, width: 120 },
  { field: 'pool', header: 'Pool', visible: true, width: 100 },
  { field: 'productsPlatform', header: 'Products and Platform', visible: true, width: 180 },
  { field: 'technology', header: 'Technology', visible: true, width: 100 },
  { field: 'global', header: 'Global', visible: true, width: 100 },
];

// 3. Project Wise Report Mock Config
const initialMockProjectWiseConfig = [
  { field: 'projectName', header: 'Project Name', visible: true, width: 250 },
  { field: 'billable', header: 'Billable', visible: true, width: 100 },
  { field: 'shadow', header: 'Sdw', visible: true, width: 80 },
  { field: 'prg', header: 'Prg M', visible: true, width: 90 },
  { field: 'pm', header: 'PM', visible: true, width: 80 },
  { field: 'srArch', header: 'Sr. Arch.', visible: true, width: 100 },
  { field: 'arch', header: 'Arch.', visible: true, width: 80 },
  { field: 'ba', header: 'BA', visible: true, width: 80 },
  { field: 'qa', header: 'QA', visible: true, width: 80 },
  { field: 'beDev', header: 'BE Dev', visible: true, width: 100 },
  { field: 'dops', header: 'Dev Ops', visible: true, width: 100 },
  { field: 'gd', header: 'Grp Design', visible: true, width: 110 },
  { field: 'fdev', header: 'FE Dev', visible: true, width: 100 },
  { field: 'ml', header: 'ML', visible: true, width: 80 },
  { field: 'etlDev', header: 'ETL Dev', visible: true, width: 100 },
  { field: 'reportDev', header: 'Report Dev', visible: true, width: 110 },
  { field: 'fullStack', header: 'Full Stack', visible: true, width: 110 },
  { field: 'other', header: 'Others', visible: true, width: 80 },
  { field: 'total', header: 'Total', visible: true, width: 90 },
];

const getStaffingExportMeta = () => {
  const now = new Date();
  const pad = (num) => num.toString().padStart(2, '0');
  const dateStr = `${pad(now.getDate())}-${pad(now.getMonth() + 1)}-${now.getFullYear()}`;

  return {
    filename: `Staffing_MIS_Details(${dateStr})`,
    sheetName: 'Staffing MIS Details',
    reportTitle: 'Staffing MIS Details',
    toolbarSheetName: 'Staffing MIS Details',
  };
};

const StaffingMis = () => {
  const { userProfile } = useAuth();
  const authToken = userProfile?.access_token || '';
  const [tableScrollHeight, setTableScrollHeight] = useState('500px');
  const [appliedFilters, setAppliedFilters] = useState([
    {
      field: 'selectedDate',
      selectedValue: defaultSelectedDate,
      selectedValues: [defaultSelectedDate],
      value: defaultSelectedDate,
      template: 'dayCalendar',
    },
    {
      field: 'sections',
      value: ['Team Size', 'Weekly Bench Report', 'Weekly Utilization Report'],
      selectedValues: ['Team Size', 'Weekly Bench Report', 'Weekly Utilization Report'],
    },
  ]);

  const paginationRef = React.useRef({ page: 1, limit: PAGE_SIZE, total: 0 });
  const handlePaginationChange = useCallback((pageInfo) => {
    paginationRef.current = pageInfo;
  }, []);

  const [roleWiseSummaryData, setRoleWiseSummaryData] = useState([]);
  const [roleWiseConfig] = useState(initialMockRoleWiseSummaryConfig);

  const [benchForecastData, setBenchForecastData] = useState([]);
  const [benchForecastConfig] = useState(initialMockBenchForecastConfig);

  const [teamSizeData, setTeamSizeData] = useState([]);

  // Calculate default fiscal years for initial mount of Team Size columns
  const initialStartYear = useMemo(() => {
    const now = new Date();
    const month = now.getMonth() + 1;
    const year = now.getFullYear();
    return month > 3 ? year : year - 1;
  }, []);

  const [teamSizeConfigState] = useState([
    { field: 'vertical', header: 'Employee Vertical', visible: true, width: 200 },
    { field: 'initialTeamSize', header: `Initial Team Size (Apr ${initialStartYear})`, visible: true, width: 220 },
    { field: 'totalNewJoins', header: 'Total New Joins', visible: true, width: 150 },
    { field: 'totalExits', header: 'Total Exists', visible: true, width: 150 },
    { field: 'currentTeamSize', header: 'Current Team Size', visible: true, width: 220 },
  ]);

  const [projectWiseData, setProjectWiseData] = useState([]);
  const [projectWiseConfigState] = useState(initialMockProjectWiseConfig);

  const handleFilteredApiResponse = useCallback((response) => {
    if (!response) return;

    // Remove pinnable and pin header options from the API response columns and add numeric alignment
    if (response.data) {
      if (response.data.tableConfiguration) {
        response.data.tableConfiguration = response.data.tableConfiguration.map((col) => ({
          ...col,
          pinnable: false,
          showPinButtonInHeader: false,
          numeric: col.field !== 'breakup',
        }));
      }
      if (response.data.data) {
        if (response.data.data.tableConfiguration) {
          response.data.data.tableConfiguration = response.data.data.tableConfiguration.map((col) => ({
            ...col,
            pinnable: false,
            showPinButtonInHeader: false,
            numeric: col.field !== 'breakup',
          }));
        }
        if (response.data.data.roleWiseSummary && response.data.data.roleWiseSummary.tableConfiguration) {
          response.data.data.roleWiseSummary.tableConfiguration = response.data.data.roleWiseSummary.tableConfiguration.map((col) => ({
            ...col,
            pinnable: false,
            showPinButtonInHeader: false,
            numeric: col.field !== 'breakup',
          }));
        }
      }
    }

    const resData = response.data?.data || response.data || {};
    if (resData.roleWiseSummary) {
      setRoleWiseSummaryData(resData.roleWiseSummary.tableData || []);
    }
    if (resData.benchForecast) {
      setBenchForecastData(resData.benchForecast.tableData || []);
    }
    if (resData.teamSize) {
      setTeamSizeData(resData.teamSize.tableData || []);
    }
    if (resData.projectWise) {
      setProjectWiseData(resData.projectWise.tableData || []);
    }
  }, []);

  const handleRoleWiseResponse = useCallback((response) => {
    handleFilteredApiResponse(response);
  }, [handleFilteredApiResponse]);

  const handleBenchForecastResponse = useCallback((response) => {
    if (response && response.data) {
      const resData = response.data?.data || response.data || {};
      if (resData.benchForecast) {
        response.data.tableConfiguration = (resData.benchForecast.tableConfiguration || []).map((col) => ({
          ...col,
          pinnable: false,
          showPinButtonInHeader: false,
          numeric: col.field !== 'weekEnding',
        }));
        response.data.tableData = resData.benchForecast.tableData || [];
      }
    }
  }, []);

  const handleTeamSizeResponse = useCallback((response) => {
    if (response && response.data) {
      const resData = response.data?.data || response.data || {};
      if (resData.teamSize) {
        response.data.tableConfiguration = (resData.teamSize.tableConfiguration || []).map((col) => ({
          ...col,
          pinnable: false,
          showPinButtonInHeader: false,
          numeric: col.field !== 'vertical',
          align: col.field === 'vertical' ? 'left' : 'center',
        }));
        const rawTableData = resData.teamSize.tableData || [];
        response.data.tableData = rawTableData.map((row) => {
          if (row.vertical === 'Total') {
            return {
              ...row,
              _isFooterRow: true,
              rowConfiguration: {
                isFrozen: true,
                backgroundColor: '#eceff5',
                fontWeight: 'bold',
                template: [
                  { field: 'vertical', fontWeight: '700' },
                  { field: 'initialTeamSize', fontWeight: '700' },
                  { field: 'totalNewJoins', fontWeight: '700' },
                  { field: 'totalExits', fontWeight: '700' },
                  { field: 'currentTeamSize', fontWeight: '700' },
                ],
              },
            };
          }
          return row;
        });
      }
    }
  }, []);

  const handleProjectWiseResponse = useCallback((response) => {
    if (response && response.data) {
      const resData = response.data?.data || response.data || {};
      if (resData.projectWise) {
        response.data.tableConfiguration = (resData.projectWise.tableConfiguration || []).map((col) => ({
          ...col,
          pinnable: false,
          showPinButtonInHeader: false,
          numeric: col.field !== 'projectName',
        }));
        response.data.tableData = resData.projectWise.tableData || [];
      }
    }
  }, []);


  const userPermissions = useMemo(() => userProfile?.permissions || {}, [userProfile]);

  const hasAccess = useMemo(
    () =>
      Array.isArray(userPermissions['mis:staffing-mis'])
      && userPermissions['mis:staffing-mis'].some((action) =>
        ['read', 'write', 'update', 'delete', 'create', 'edit'].includes(action.toLowerCase()),
      ),
    [userPermissions],
  );

  const staffingUserInfo = useMemo(() => ({
    emailId: userProfile?.email || '',
    permissions: userProfile?.permissions || {},
    roleDetails: userProfile?.roleDetails || [],
    employeeId: userProfile?.employeeId || '',
    globalColors: userProfile?.siteConfiguration?.global_colors || {},
  }), [userProfile]);


  const handleFilterUpdate = useCallback(({ action, filters }) => {
    setRoleWiseSummaryData([]);
    setBenchForecastData([]);
    setTeamSizeData([]);
    setProjectWiseData([]);
    if (action === 'reset') {
      setAppliedFilters([]);
      return;
    }
    setAppliedFilters(filters || []);
  }, []);

  const activeSections = useMemo(() => {
    console.log('appliedFilters updated in StaffingMis:', appliedFilters);
    const sectionsFilter = appliedFilters.find((f) => f.field === 'sections');
    if (!sectionsFilter) return [];

    const rawValues = sectionsFilter.selectedValues
      || sectionsFilter.selectedValue
      || sectionsFilter.value
      || [];

    const valuesArray = Array.isArray(rawValues) ? rawValues : [rawValues];

    const extracted = valuesArray
      .filter(v => v !== null && v !== undefined && v !== '')
      .map(v => {
        if (typeof v === 'object') {
          return v.value || v.label || '';
        }
        return String(v);
      })
      .filter(Boolean);

    console.log('Extracted activeSections:', extracted);
    return extracted;
  }, [appliedFilters]);

  const shouldShowSection = useCallback((sectionName) => {
    if (activeSections.length === 0) return ['Team Size', 'Weekly Bench Report', 'Weekly Utilization Report'].includes(sectionName);
    return activeSections.includes(sectionName);
  }, [activeSections]);

  const staffingExportMeta = useMemo(() => getStaffingExportMeta(), []);

  // Normalize column definitions for global config
  const normalizedGlobalConfig = useMemo(() => {
    return mockGlobalConfiguration;
  }, []);

  // Normalize column definitions for all 4 tables from dynamic state configs
  const normalizedRoleWiseConfig = useMemo(() => {
    return roleWiseConfig.map((col) => ({
      ...col,
      filter: false,
      pinnable: false,
      showFilterButtonInHeader: false,
      showPinButtonInHeader: false,
      numeric: col.field !== 'breakup',
    }));
  }, [roleWiseConfig]);

  const normalizedBenchForecastConfig = useMemo(() => {
    return benchForecastConfig.map((col) => ({
      ...col,
      filter: false,
      pinnable: false,
      showFilterButtonInHeader: false,
      showPinButtonInHeader: false,
      numeric: col.field !== 'weekEnding',
    }));
  }, [benchForecastConfig]);

  const selectedDate = useMemo(() => {
    const dateFilter = appliedFilters.find((f) => f.field === 'selectedDate');
    const val = dateFilter?.selectedValue || dateFilter?.value || '';
    if (typeof val === 'string') {
      const match = val.match(/^(\d{1,2})[/-](\d{4})$/);
      const dayMatch = val.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (dayMatch) {
        const [, y, m, d] = dayMatch;
        return new Date(Number(y), Number(m) - 1, Number(d));
      }
      if (match) {
        const [, m, y] = match;
        return new Date(Number(y), Number(m) - 1, 1);
      }
    }
    if (val instanceof Date) return val;
    return new Date();
  }, [appliedFilters]);

  const { startYear, endYear } = useMemo(() => {
    const month = selectedDate.getMonth() + 1;
    const year = selectedDate.getFullYear();
    if (month > 3) {
      return { startYear: year, endYear: year + 1 };
    }
    return { startYear: year - 1, endYear: year };
  }, [selectedDate]);

  const normalizedTeamSizeConfig = useMemo(() => {
    return teamSizeConfigState.map((col) => {
      let header = col.header;
      if (col.field === 'initialTeamSize') {
        header = `Initial Team Size (Apr ${startYear})`;
      }
      return {
        ...col,
        header,
        filter: false,
        pinnable: false,
        showFilterButtonInHeader: false,
        showPinButtonInHeader: false,
        numeric: col.field !== 'vertical',
        align: col.field === 'vertical' ? 'left' : 'center',
      };
    });
  }, [teamSizeConfigState, startYear, endYear]);

  const normalizedProjectWiseConfig = useMemo(() => {
    return projectWiseConfigState.map((col) => ({
      ...col,
      filter: false,
      pinnable: false,
      showFilterButtonInHeader: false,
      showPinButtonInHeader: false,
      numeric: col.field !== 'projectName',
    }));
  }, [projectWiseConfigState]);

  // Configuration for the main top-level Staffing MIS toolbar
  const headerToolbarConfig = useMemo(() => ({
    generalSettings: {
      enableApiFiltering: false,
      baseURL,
      showToolBar: true,
      showPagination: false,
      headers: { token: authToken },
      userInfo: staffingUserInfo,
      apiEndpoints: {
        getAllViews: { endpoint: '', enabled: false },
        getFilteredData: { endpoint: '', enabled: false },
        saveOrUpdateView: { endpoint: '', enabled: false },
        deleteView: { endpoint: '', enabled: false },
      },
      handler: {
        onFilterUpdate: handleFilterUpdate,
        setTableStateHandler: () => { },
      },
      toolBarSettings: {
        showFilterOption: true,
        showColumnFilterMenu: true,
        showAddNew: false,
        showExpandCollapse: false,
        showDownloadExcel: false,
        downloadExcelSheetName: staffingExportMeta.toolbarSheetName,
        showColumnCustomize: false,
        showHelp: false,
        showSearch: false,
        showSaveView: false,
        showToolBarHeading: true,
        toolBarHeading: 'Staffing MIS',
        showReset: false,
        showFilters: true,
        additionalElements: [],
      },
    },
    showFilterOption: true,
    showExpandCollapse: false, // Root-level property
    tableSettings: {
      size: 'small',
      tableScrollHeight: '100%',
      tableConfig: normalizedGlobalConfig,
      paginationConfig: { ...DEFAULT_PAGINATION_CONFIG },
      showExpandCollapse: false,
      enableTreeTable: false, // Flat table layout
    },
  }), [staffingUserInfo, staffingExportMeta, normalizedGlobalConfig, handleFilterUpdate, authToken]);
  // Base configurations for tables (no toolbar, no pagination)
  const roleWiseSummaryTableConfig = useMemo(() => ({
    generalSettings: {
      enableApiFiltering: true,
      showToolBar: true,
      showPagination: false,
      userInfo: staffingUserInfo,
      baseURL,
      headers: { token: authToken },
      apiEndpoints: {
        getFilteredData: { endpoint: '', enabled: true },
        download: {
          endpoint: 'export',
          enabled: true,
          additionalPayloadData: { section: 'roleWiseSummary' },
        },
      },
      handler: {
        handleFilteredApiResponse: handleRoleWiseResponse,
      },
      toolBarSettings: {
        showFilterOption: false,
        showColumnFilterMenu: false,
        showAddNew: false,
        showExpandCollapse: false,
        showDownloadExcel: true,
        downloadExcelSheetName: 'Role Wise Summary',
        showColumnCustomize: false,
        showHelp: false,
        showSearch: false,
        showSaveView: false,
        showToolBarHeading: true,
        toolBarHeading: 'Role Wise Summary',
        showReset: false,
        showFilters: false,
      },
    },
    showExpandCollapse: false,
    tableSettings: {
      size: 'small',
      tableScrollHeight,
      tableConfig: normalizedRoleWiseConfig,
      enableTreeTable: false,
      showExpandCollapse: false,
      loaderSkeleton: {
        rows: 5,
        bodyCells: 1,
        columns: normalizedRoleWiseConfig.length || 13,
      },
      paginationConfig: {
        ...DEFAULT_PAGINATION_CONFIG,
        ...paginationRef.current,
        onPaginationChange: handlePaginationChange,
      },
    },
  }), [tableScrollHeight, normalizedRoleWiseConfig, staffingUserInfo, authToken, handleRoleWiseResponse, handlePaginationChange]);

  const benchForecastTableConfig = useMemo(() => ({
    generalSettings: {
      enableApiFiltering: true,
      showToolBar: true,
      showPagination: false,
      userInfo: staffingUserInfo,
      baseURL,
      headers: { token: authToken },
      apiEndpoints: {
        getFilteredData: { endpoint: '', enabled: true },
        download: {
          endpoint: 'export',
          enabled: true,
          additionalPayloadData: { section: 'benchForecast' },
        },
      },
      handler: {
        handleFilteredApiResponse: handleBenchForecastResponse,
      },
      toolBarSettings: {
        showFilterOption: false,
        showColumnFilterMenu: false,
        showAddNew: false,
        showExpandCollapse: false,
        showDownloadExcel: true,
        downloadExcelSheetName: 'Bench Forecast',
        showColumnCustomize: false,
        showHelp: false,
        showSearch: false,
        showSaveView: false,
        showToolBarHeading: true,
        toolBarHeading: 'Bench Forecast',
        showReset: false,
        showFilters: false,
      },
    },
    showExpandCollapse: false,
    tableSettings: {
      size: 'small',
      tableScrollHeight,
      tableConfig: normalizedBenchForecastConfig,
      enableTreeTable: false,
      showExpandCollapse: false,
      loaderSkeleton: {
        rows: 5,
        bodyCells: normalizedBenchForecastConfig.length || 5,
        columns: normalizedBenchForecastConfig.length || 5,
      },
      paginationConfig: { ...DEFAULT_PAGINATION_CONFIG },
    },
  }), [tableScrollHeight, normalizedBenchForecastConfig, staffingUserInfo, authToken, handleBenchForecastResponse]);

  const teamSizeTableConfig = useMemo(() => ({
    generalSettings: {
      enableApiFiltering: true,
      showToolBar: true,
      showPagination: false,
      userInfo: staffingUserInfo,
      additionalPayloadData: { filter: appliedFilters, section: 'teamSize' },
      baseURL,
      headers: { token: authToken },
      apiEndpoints: {
        getFilteredData: { endpoint: '', enabled: true },
        download: {
          endpoint: 'export',
          enabled: true,
          additionalPayloadData: { section: 'teamSize' },
        },
      },
      handler: {
        handleFilteredApiResponse: handleTeamSizeResponse,
      },
      toolBarSettings: {
        showFilterOption: false,
        showColumnFilterMenu: false,
        showAddNew: false,
        showExpandCollapse: false,
        showDownloadExcel: true,
        downloadExcelSheetName: 'Team Size',
        showColumnCustomize: false,
        showHelp: false,
        showSearch: false,
        showSaveView: false,
        showToolBarHeading: true,
        toolBarHeading: `Team Size(FY ${startYear}-${endYear})`,
        showReset: false,
        showFilters: false,
      },
    },
    showExpandCollapse: false,
    tableSettings: {
      size: 'small',
      tableScrollHeight,
      tableConfig: normalizedTeamSizeConfig,
      enableTreeTable: false,
      showExpandCollapse: false,
      loaderSkeleton: {
        rows: 5,
        bodyCells: normalizedTeamSizeConfig.length || 5,
        columns: normalizedTeamSizeConfig.length || 5,
      },
      paginationConfig: { ...DEFAULT_PAGINATION_CONFIG },
    },
  }), [tableScrollHeight, normalizedTeamSizeConfig, staffingUserInfo, startYear, endYear, authToken,
    handleTeamSizeResponse, appliedFilters]);

  const projectWiseTableConfig = useMemo(() => ({
    generalSettings: {
      enableApiFiltering: true,
      showToolBar: true,
      showPagination: false,
      userInfo: staffingUserInfo,
      baseURL,
      headers: { token: authToken },
      apiEndpoints: {
        getFilteredData: { endpoint: '', enabled: true },
        download: {
          endpoint: 'export',
          enabled: true,
          additionalPayloadData: { section: 'projectWise' },
        },
      },
      handler: {
        handleFilteredApiResponse: handleProjectWiseResponse,
      },
      toolBarSettings: {
        showFilterOption: false,
        showColumnFilterMenu: false,
        showAddNew: false,
        showExpandCollapse: false,
        showDownloadExcel: true,
        downloadExcelSheetName: 'Project Wise Report',
        showColumnCustomize: false,
        showHelp: false,
        showSearch: false,
        showSaveView: false,
        showToolBarHeading: true,
        toolBarHeading: 'Project Wise Summary',
        showReset: false,
        showFilters: false,
      },
    },
    showExpandCollapse: false,
    tableSettings: {
      size: 'small',
      tableScrollHeight,
      tableConfig: normalizedProjectWiseConfig,
      enableTreeTable: false,
      showExpandCollapse: false,
      loaderSkeleton: {
        rows: 5,
        bodyCells: normalizedProjectWiseConfig.length || 5,
        columns: normalizedProjectWiseConfig.length || 5,
      },
      paginationConfig: { ...DEFAULT_PAGINATION_CONFIG },
    },
  }), [tableScrollHeight, normalizedProjectWiseConfig, staffingUserInfo, authToken, handleProjectWiseResponse]);

  // Handle height resize
  useEffect(() => {
    const handleResize = () => {
      setTableScrollHeight(`${Math.floor(window.innerHeight * 0.65)}px`);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (!hasAccess) {
    return (
      <div style={{ padding: '40px 20px', textAlign: 'center', color: '#666', fontSize: '16px' }}>
        You do not have permission to view Staffing MIS.
      </div>
    );
  }

  return (
    <div className="staffing-mis-outer-layer">
      <div className="staffing-mis-table-container" style={{ position: 'relative' }}>
        {/* 1. Main Staffing MIS Header Toolbar */}
        <div className="staffing-mis-table-utility table-utility staffing-no-data">
          <TableUtility
            key="staffing-mis-header-toolbar"
            configuration={headerToolbarConfig}
            data={[]}
            externalFilters={appliedFilters}
            showFilterOption
            showExpandCollapse={false}
          />
        </div>

        {/* 2. Role Wise Summary */}
        {(shouldShowSection('Role Summary') || shouldShowSection('Role Wise Summary')) && (
          <div className="staffing-mis-section">
            <div className="staffing-mis-table-utility table-utility role-wise-table">
              <TableUtility
                key="role-wise-summary-table"
                configuration={roleWiseSummaryTableConfig}
                data={roleWiseSummaryData}
                externalFilters={appliedFilters}
                showExpandCollapse={false}
              />
            </div>
          </div>
        )}

        {/* 3. Bench Forecast */}
        {shouldShowSection('Bench Forecast') && (
          <div className="staffing-mis-section">
            <div className="staffing-mis-table-utility table-utility bench-forecast-table">
              <TableUtility
                key="bench-forecast-table"
                configuration={benchForecastTableConfig}
                data={benchForecastData}
                externalFilters={appliedFilters}
                showExpandCollapse={false}
              />
            </div>
          </div>
        )}

        {/* 4. Team Size */}
        {shouldShowSection('Team Size') && (
          <div className="staffing-mis-section team-size-section">
            <div className="staffing-mis-table-utility table-utility">
              <TableUtility
                key={`team-size-table-${JSON.stringify(appliedFilters)}`}
                configuration={teamSizeTableConfig}
                data={teamSizeData}
                externalFilters={appliedFilters}
                showExpandCollapse={false}
              />
            </div>
          </div>
        )}

        {shouldShowSection('Weekly Utilization Report') && (
          <WeeklyUtilizationReport embedded externalAppliedFilters={appliedFilters} />
        )}

        {shouldShowSection('Weekly Bench Report') && (
          <WeeklyBenchReport embedded externalAppliedFilters={appliedFilters} />
        )}

        {/* 5. Project Wise Report */}
        {shouldShowSection('Project Wise Summary') && (
          <div className="staffing-mis-section">
            <div className="staffing-mis-table-utility table-utility project-wise-table">
              <TableUtility
                key="project-wise-table"
                configuration={projectWiseTableConfig}
                data={projectWiseData}
                externalFilters={appliedFilters}
                showExpandCollapse={false}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StaffingMis;
